import { createAsyncThunk } from '@reduxjs/toolkit'
import { paginationData } from '../Pagination/reducers'
import { LogsListApi } from './Logs.services'

export const LogsList = createAsyncThunk(
    'Logs/List',
    async (data, { rejectWithValue, dispatch, getState }) => {
        try {
            const state = getState()
            const clubId = data.club_id || state.Login.admin?.club_id
            
            const requestData = {
                ...data,
                club_id: clubId
            }
            
            const res = await LogsListApi(requestData)

            if (res && res.totalRecords !== undefined) {
                const limit = data._limit || 10
                const currentPage = data._page || 1
                const totalRecords = res.totalRecords || 0
                const totalPage = Math.ceil(totalRecords / limit) || 1
                
                const paginationObj = {
                    page: currentPage,
                    totalPage,
                    totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            
            const paginationObj = {
                page: 1,
                totalPage: 1,
                totalRecords: 0
            }
            dispatch(paginationData(paginationObj))
            
            if (!err.response) {
                throw err
            }
            return rejectWithValue(err.response.data)
        }
    }
)